
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { AgreementEffects } from '@appStore/selfservice/effects/agreement.effects';
import { FormsEffects } from '@appStore/selfservice/effects/forms.effects';
import { BookingEffects } from '@appStore/selfservice/effects/booking.effects';


export const effects: any[] = [
  AgreementEffects, FormsEffects, BookingEffects
];

@NgModule({
  imports: [EffectsModule.forFeature(effects)]
})
export class SelfServiceEffectsModule {}
